import { BookingCheckout } from '@drycut/booking-components';
import {
  CenteredSquaredContainer,
  FatalErrorWithStack,
  FullscreenImageLayout,
  Heading,
  Stack,
} from '@drycut/ui-components';
import { ErrorBoundary } from '@rollbar/react';
import { useParams } from 'react-router';
import { useDocumentTitle } from 'usehooks-ts';

export function NewBookingCheckout(): React.ReactElement {
  useDocumentTitle('DRYCUT - New booking');

  const { slug } = useParams() as { slug: string };

  return (
    <FullscreenImageLayout src="/images/booking-bg.jpg">
      <Stack className="lg:mt-[20vh]">
        <Heading className="hidden lg:block">right hair. right now.</Heading>
        <CenteredSquaredContainer
          wrapperClassName="overflow-hidden"
          className="2xl:w-full lg:w-full xs:m-0 md:m-0 xl:m-10 lg:px-10 2xl:px-10 max-w-screen-2xl"
        >
          <ErrorBoundary fallbackUI={FatalErrorWithStack}>
            <BookingCheckout storeSlug={slug} />
          </ErrorBoundary>
        </CenteredSquaredContainer>
      </Stack>
    </FullscreenImageLayout>
  );
}
